<template>
    <div>
        <div id="create-campaign">
            <div class="app-container my-5" v-show="!$global.loading">

                <div class="d-flex justify-content-between">

                    <div class="page-title mb-3">
                        <router-link to="/campaigns">
                            <span class="breadcrumb-link">
                                <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Campagnes
                            </span>
                        </router-link>
                        <v-icon>keyboard_arrow_right</v-icon>
                        <span class="breadcrumb-item">
                            <v-icon class="breadcrumb-item-icon">mdi-plus-circle</v-icon> Création d'une Campagne
                            d'adhésion
                        </span>
                    </div>

                    <div>
                        <v-tooltip slot="append-outer" bottom v-if="account.cadh_configurations.length === 0">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="warning">warning</v-icon>
                            </template>
                            <span>Aucun formulaire d'adhésion n'est configuré sur votre compte.</span>
                        </v-tooltip>
                    </div>
                </div>

                <v-text-field v-model="campaign.name" background-color="white" label="Nom de votre campagne" outlined>
                </v-text-field>

                <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Sélection
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Validation prestataires
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Formulaire
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="5">
                            Options
                        </v-stepper-step>

                        <v-stepper-step editable step="6">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <filters></filters>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <verification></verification>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <configuration-choice></configuration-choice>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <email v-if="providers.length || selectedApidaeSelection"></email>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                            <options :update-mode="false" :criterias="criterias" :is-revival="false">
                            </options>
                        </v-stepper-content>

                        <v-stepper-content step="6">
                            <finalize :cadh-name="campaign.name" :update-mode="false" :criterias="criterias"
                                      :is-revival="false">
                            </finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
import Finalize from "@/components/campaign/cadh/stepers/Finalize"
import Email from "@/components/campaign/cadh/stepers/Email"
import Verification from "@/components/campaign/cadh/stepers/Verification"
import Filters from "@/components/campaign/cadh/stepers/Filters"
import { mapMutations, mapState } from "vuex"
import Options from "@/components/campaign/cadh/stepers/Options"
import ConfigurationChoice from "./stepers/ConfigurationChoice.vue"

export default {
    name: "CreateCampaignScratch",
    components: { Finalize, Email, Verification, Filters, Options, ConfigurationChoice },
    data() {
        return {
            campaign: { name: null },
            criterias: [],
            selectedCriterias: [],
        }
    },
    methods: {
        ...mapMutations("createCadh", ["setCurrentStep", "setFirstPartMail", "setLastPartMail", "setSender", "resetState"]),
        initDefaultName() {
            let year = this.$moment().format("YYYY")

            this.campaign.name = "Campagne d'adhésion " + year
        },
        initFirstPartEmail() {
            let text = "<p>Cher(e) partenaire,</p>" +
              "<p>Nous vous sollicitons afin de vous proposer de renouveler votre adhésion, ou de rejoindre notre réseau d’adhérents, pour cette nouvelle année.</p> " +
              "<p>Au moyen du questionnaire accessible via le bouton ci-dessous, nous vous invitons à compléter votre formulaire d’adhésion et de choisir l'offre souhaitée.</p>"

            this.setFirstPartMail(text)
        },
        initLastPartEmail() {
            let text = "<p>Nous vous remercions pour votre confiance.</p>" +
              "<p>Nous restons à votre disposition pour toute question complémentaire.</p>"

            this.setLastPartMail(text)
        },
        getInternalCriterias() {
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
    },
    computed: {
        ...mapState("account", ["senders", "account"]),
        ...mapState("createCadh", ["currentStep", "emailsValid", "providers", "selectedApidaeSelection"]),
    },
    created() {
        this.resetState()
        this.$store.dispatch("account/fetchContacts")
        this.$store.dispatch("account/fetchCategories")
        this.$store.dispatch("account/fetchCommunes")

        this.initDefaultName()
        this.initFirstPartEmail()
        this.initLastPartEmail()
        this.getInternalCriterias()

        this.$store.dispatch("account/loadSenders").then(() => {
            if (this.senders.length) {
                this.setSender(this.senders[0])
            }
        })
    },
}
</script>